// Wortlaute der Zeiterfassungs-Erklärung. Regeln für jeden Text: siehe ../help.js.
export default {
  title: "Zeiterfassung",
  // Beschreibung der Beispielseite, die statt eines echten Ausdrucks gezeigt wird.
  image: {
    certificate: "Beispiel eines Monatsnachweises als PDF",
  },
  // Kurznamen der besuchten Seiten, für die Kopfzeile, die Zeitleiste und "Weiter zu …".
  // Absichtlich kürzer als die Seitentitel, weil sie mitten in einem Satz stehen.
  section: {
    TimeTrackingMy: "Meine Zeiten",
    TimeTrackingReview: "Prüfung",
    SettingsOverview: "Arbeitszeitmodelle",
    EmployeeDetail: "Zuordnung",
    ProjectDetail: "Projekt",
    PersonnelCalendar: "Personalplanung",
  },
  // Die Seiten außerhalb der Zeiterfassung, die sie einrichten und die ihre Stunden weiterverwenden.
  // In der Zeitleiste abgesetzt.
  related: "Zusammenhänge",
  step: {
    nav: { text: "Diese Leiste ist die Navigation der Zeiterfassung. Jeder Reiter öffnet einen eigenen Bereich." },
    "tab-my": {
      text: "Hier erfassen und korrigieren Sie Ihre eigene Woche.",
    },
    "tab-review": {
      text: "Hier prüfen Sie die Zeiten Ihrer Mitarbeitenden, geben sie frei und sehen, wer gerade da ist.",
    },

    "review-filters": {
      text: "Hier wählen Sie Mitarbeitende, Zeitraum, Status und Projekt. Das Raster darunter zeigt nur, was dazu passt.",
    },
    clock: { text: "Mit der Uhr stempeln Sie ein und wieder aus. Sie zeigt, ob gerade eine Erfassung läuft." },
    "clock-project": {
      text: "Vor dem Einstempeln wählen Sie das Projekt. Ein paar Buchstaben genügen, um es zu finden.",
    },
    "clock-chip": {
      text: "Läuft die Uhr, steht sie oben in der Leiste, auf jeder Seite. Dort stempeln Sie auch aus.",
    },
    "clock-break": {
      text: "Mit Pause halten Sie die Uhr an. Beginn und Ende der Pause stehen danach im Nachweis, so wie es das Arbeitszeitgesetz verlangt.",
    },
    "clock-in": {
      text: "Ein Klick auf Einstempeln startet die Uhr. Beim Ausstempeln wird daraus der Eintrag des Tages.",
    },
    "entry-open": {
      text: "Mit Zeit erfassen tragen Sie einen Tag von Hand nach. Alles Nötige steht in diesem Fenster.",
    },
    "entry-basics": {
      text: "Datum, Beginn, Ende und Projekt tragen Sie hier ein. Das Projekt ist schon vorbelegt, aus der Personalplanung für diesen Tag, und lässt sich mit ein paar Buchstaben ändern.",
    },
    "entry-break": {
      text: "Eine Pause fügen Sie mit einem Klick ein. Darunter rechnet sich der Tag sofort neu aus.",
    },
    "entry-note": {
      text: "Eine Notiz erklärt den Tag. Mit Speichern ist er erfasst, hier brechen wir ab, denn es sind Beispieldaten.",
    },
    export: {
      text: "Über dieses Menü laden Sie Ihre Zeiten als CSV-Datei herunter. Ein Klick auf Monatsnachweis erzeugt Ihren Monat als PDF.",
    },
    "export-certificate": {
      text: "Der Monatsnachweis listet jeden Tag des Monats mit Summen und Kontostand. Darunter unterschreiben Sie und Ihr Vorgesetzter.",
    },
    week: { text: "Alles auf dieser Seite gehört zu einer Woche. Mit den Pfeilen blättern Sie vor und zurück." },
    "week-back": {
      text: "Ein Klick zurück zeigt die Vorwoche. Kacheln, Liste und Diagramm folgen der gewählten Woche.",
    },
    "stat-actual": { text: "Die Ist-Zeit ist alles, was in dieser Woche erfasst ist." },
    "stat-target": { text: "Die Soll-Zeit kommt aus Ihrem Arbeitszeitmodell." },
    "stat-balance": { text: "Der Saldo ist die Differenz aus Ist und Soll. Rot heißt, es fehlen noch Stunden." },
    "stat-days": { text: "So viele Tage sind in dieser Woche erfasst. Darunter steht die Zahl der Einträge." },
    account: { text: "Der Stand Ihres Stundenkontos über alle Wochen hinweg." },
    entries: { text: "Hier stehen die einzelnen Tage der Woche." },
    "entry-row": {
      text: "Jede Zeile zeigt Zeiten, Projekt, Pause und Saldo. Rechts steht, ob der Tag schon freigegeben ist.",
    },
    chart: { text: "Das Diagramm zeigt die Stunden je Tag, gemessen am Soll." },
    "chart-filter": {
      text: "Ein Klick auf einen Tag im Diagramm filtert die Liste links auf diesen Tag. Ein zweiter Klick hebt den Filter wieder auf.",
    },
    projects: { text: "Hier verteilt sich die Woche auf die Projekte." },
    "project-filter": {
      text: "Auch ein Klick auf ein Projekt filtert die Liste links. So sehen Sie schnell, an welchen Tagen Sie dort waren.",
    },
    matrix: {
      text: "Eine Zeile je Mitarbeiter, eine Spalte je Tag des Zeitraums. So sieht man auf einen Blick, wo etwas fehlt.",
    },
    "matrix-mode": {
      text: "Hier stellen Sie um, was in den Zellen steht. Zu Beginn ist es die Arbeitszeit, also die erfassten Stunden je Tag.",
    },
    "mode-balance": {
      text: "Saldo zeigt je Tag den Unterschied zum Soll. Grün liegt darüber, orange darunter.",
    },
    "mode-status": {
      text: "Status zeigt, wie weit jeder Tag ist. E steht für erfasst, F für freigegeben und A für abgelehnt.",
    },
    "matrix-violations": {
      text: "Als Verstöße gelesen zeigt die Matrix die Tage gegen das Arbeitszeitgesetz. Das § in der Ecke steht auch in den anderen Ansichten.",
    },
    "matrix-day-head": {
      text: "Das Datum über einer Spalte ist eine Schaltfläche. Ein Klick beurteilt den ganzen Tag, also alle Zeiten dieser Spalte auf einmal.",
    },
    "matrix-create": {
      text: "Unter dem Zeiger zeigt ein Tag ohne Erfassung ein Plus. Ein Klick öffnet das Fenster für diese Person und diesen Tag.",
    },
    "matrix-pick-ctrl": {
      text: "Mit gedrückter Strg-Taste markieren Sie einzelne Zellen, auch mit Lücken dazwischen. Ein zweiter Strg-Klick nimmt eine Zelle wieder heraus.",
    },
    "matrix-pick-shift": {
      text: "Umschalt nimmt das ganze Rechteck bis zur geklickten Zelle, auch über mehrere Personen. Die Leiste darunter gibt die Zeiten darin frei oder trägt eine Abwesenheit ein.",
    },
    "matrix-absence": {
      text: "Ein Tag mit Abwesenheit zeigt sie oben im Fenster, eine bezahlte mit ihrer Gutschrift. Tag entfernen nimmt nur diesen einen Tag heraus.",
    },
    "matrix-cell": {
      text: "Ein Klick auf eine Zelle öffnet den Tag: Zeiten, Pause, Projekt, Erfassungsart, Prüfnotiz und die Schaltflächen zum Freigeben, Ablehnen und Korrigieren.",
    },
    total: { text: "Am Fuß der Matrix steht die Summe des Zeitraums. Das ist die Zahl, die Sie freigeben." },
    "review-crew-open": {
      text: "Das Fenster ist schon auf diese Person und diesen Tag gestellt. Oben öffnet die Sammelerfassung dasselbe Fenster ohne Vorauswahl.",
    },
    "review-crew": {
      text: "Weitere Personen bekommen dieselben Zeiten, etwa eine ganze Kolonne. Das Projekt kommt aus der Personalplanung.",
    },
    "review-crew-save": {
      text: "Erfassen legt die Zeiten für alle an. Die Lücke im Raster ist danach gefüllt.",
    },
    "review-absence-open": {
      text: "Dasselbe Fenster hat zwei Reiter. Unter Abwesenheit tragen Sie Urlaub, Krankheit oder einen Termin ein, genau wie in der Personalplanung.",
    },
    "review-absence-kind": {
      text: "Wählen Sie die Art und wie viel vom Tag. Ganzer Tag, halber Tag oder von bis für einen Termin.",
    },
    "review-absence-rules": {
      text: "Bezahlte Abwesenheiten zählen auf dem Konto wie gearbeitet. Passt eine an einem Tag nicht neben eine vorhandene, fragt das Fenster vor dem Speichern nach.",
    },
    "review-approve": {
      text: "Das gibt alle noch nicht freigegebenen Zeiten der gewählten Personen im Zeitraum auf einmal frei, auch die, die ein Filter gerade ausblendet. Selbst erfasste Zeiten bleiben dabei außen vor. Vorher kommt eine Rückfrage.",
    },
    "review-export": { text: "Den Zeitraum exportieren Sie als CSV-Datei, zum Beispiel für die Lohnabrechnung." },
    "attendance-bar": {
      text: "Ganz oben steht, wer gerade eingestempelt ist. Ein Klick auf die Leiste klappt die Namen auf.",
    },
    "attendance-stale": {
      text: "Wer seit einem früheren Tag nicht ausgestempelt hat, steht ganz oben und ist markiert.",
    },
    "only-gaps": {
      text: "Nur mit fehlenden Tagen lässt nur die stehen, denen im Zeitraum ein Tag fehlt, die meisten zuerst. Das war früher eine eigene Seite.",
    },
    "account-bar": {
      text: "Das Arbeitszeitkonto sind die zwei letzten Spalten jeder Zeile. Sie folgen dem Zeitraum der Seite, aber nicht dem Status- und Projektfilter.",
    },
    "account-table": {
      text: "Der Übertrag ist das Guthaben, das die Person in den Zeitraum mitgebracht hat. Der Stand ist, wo sie am Ende steht: Übertrag plus Saldo.",
    },
    "account-row": {
      text: "Ein Klick auf den Namen öffnet das ganze Konto dieser Person: der Stand groß, darunter die Größen, aus denen er sich ergibt. Bezahlte Abwesenheiten stehen dort als Gutschrift.",
    },
    "account-months": {
      text: "Darunter das Konto Monat für Monat. Das Symbol am Ende jeder Zeile erzeugt den Nachweis dieses Monats als PDF.",
    },
    "account-certificate": {
      text: "So sieht der Nachweis aus. Er listet jeden Tag des Monats mit Summen und Kontostand, darunter unterschreiben beide Seiten.",
    },
    "account-export": {
      text: "Über den Export laden Sie die Konten als CSV-Datei, etwa für das Lohnbüro.",
    },
    again: { text: "Diese Schaltfläche steht auf jeder Seite mit Erklärung. Ein Klick startet sie erneut." },
    models: {
      text: "Aus diesen Modellen rechnet die Zeiterfassung Soll, Saldo und Pausen. Welches Modell für wen gilt, steht am Mitarbeiter. Das Modell mit „Standard“ ist beim Anlegen eines Mitarbeiters vorbelegt.",
    },
    "model-limits": {
      text: "Einen Tag über der Tageshöchstarbeitszeit nimmt das Formular nicht an, gestempelt steht er unter Verstöße. Die Rundung gilt für die Arbeitszeit jedes Tages.",
    },
    "model-days": {
      text: "Das Soll je Wochentag ist das Soll in Meine Zeiten und in Zeiten prüfen. Ein Tag ohne Soll ist kein Arbeitstag; ein Tag mit Soll und ohne Eintrag zählt dort als fehlend.",
    },
    "model-breaks": {
      text: "Die Pausenregeln ziehen die Mindestpause ab, auch wenn weniger eingetragen ist. Wurde zu wenig Pause gemacht, steht der Tag unter Verstöße.",
    },
    "employee-tabs": {
      text: "Das Arbeitszeitmodell ordnen Sie am Mitarbeiter zu, im Reiter Unternehmens-relevant.",
    },
    assignment: {
      text: "Jeder Tag rechnet mit dem Modell, das an diesem Tag galt. Ohne Zuweisung hat ein Tag kein Soll, auch wenn es ein Standardmodell gibt. Der Anfangssaldo darunter ist der Übertrag, mit dem sein Arbeitszeitkonto beginnt.",
    },
    "project-times": {
      text: "Die auf ein Projekt erfassten Stunden stehen am Projekt selbst, im Register Zeiten. Dort sind sie je Mitarbeiter und Bauabschnitt summiert.",
    },
    "project-reconciliation": {
      text: "Darunter steht jeder gestempelte Tag, den [[hwr:kein/keine/kein]] [[hwr]] und [[cr:kein/keine/kein]] [[cr]] des Projekts abdeckt. Auch Berichte mit deutlich anderen Stunden stehen hier.",
    },
    "planning-absence": {
      text: "Ein ganzer Tag Abwesenheit aus der Personalplanung zählt in Zeiten prüfen nicht als fehlender Tag. Die Zelle zeigt dort die Abwesenheit, und Zeiten prüfen kann sie auch selbst eintragen.",
    },
  },
  // Was der Zeiger in das Notizfeld tippt. Übersetzt, damit niemand auf Englisch zusieht, wie
  // ein deutscher Satz getippt wird.
  typed: {
    note: "Material in Halle 2 abgeholt",
  },
}
